module.exports = __webpack_public_path__ + "img/icon-dorm-male.6c48742c.svg";